import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectLoanDenialReasons = createSelector(
  selectLoanApplication,
  ({ loanDenial }) => loanDenial,
);

export const selectFlatLoanDenialReasons = createSelector(selectLoanDenialReasons, loanDenial =>
  loanDenial.map(denial => ({ ...denial, ...denial.denialReason })),
);
